import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';

/*
  Mute Toggle Button

  Controls whether the media player's audio is muted or not.
*/
export default class MuteToggleButton extends Reflux.Component{
  constructor(props){
    super(props)
    this.state = {}
    this.store = props.ControlsStore;
    this.ControlsActions = this.store.ControlsActions;
  }
  getMuteButtonClass(){
      return cx({
        'unmute': this.state.volume==0,
        'volume-low': (this.state.volume > 0 && this.state.volume <= 0.33),
        'volume-med': (this.state.volume > 0.33 && this.state.volume <= 0.66),
        'volume-high': (this.state.volume > 0.66)
    });
  }
  componentDidMount() {
      this.bindEvents();
  }
  componentDidUpdate(prevProps, prevState){
      this.bindEvents();
  }

  bindEvents(){
      //let $this = $(ReactDOM.findDOMNode(this));
  }
  shouldComponentUpdate(nextProps, nextState){
    return nextState.volume!=this.state.volume;
  }
  render() {
      let muteButtonClass = this.getMuteButtonClass();
      let muteButtonProps = {
        className: muteButtonClass,
        onClick: (e)=>{
            e.preventDefault();
            this.ControlsActions.toggleMute();
        }
      }
    return(
      <div className="button-mute">
        <button {...muteButtonProps}></button>
      </div>
    )

  }
} // MuteToggleButton
MuteToggleButton.propTypes={
    ControlsStore: React.PropTypes.object.isRequired
}
MuteToggleButton.defaultProps={
}



// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/mute-toggle-button.jsx